var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 11.0002C13.5314 11.0002 15.5834 8.94813 15.5834 6.41683C15.5834 3.88552 13.5314 1.8335 11.0001 1.8335C8.46878 1.8335 6.41675 3.88552 6.41675 6.41683C6.41675 8.94813 8.46878 11.0002 11.0001 11.0002Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8741 20.1667C18.8741 16.6192 15.3449 13.75 10.9999 13.75C6.6549 13.75 3.12573 16.6192 3.12573 20.1667",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6a1139f98e8f7c0d0fa3785e70ccb61f.svg";
export { ForwardRef as ReactComponent };